<ng-template #menu>
  <div cdkMenu class="submenu" [ngClass]="menuClasses" [ngStyle]="menuStyles">
    @for (group of menuGroupsInput; track $index; let first = $first; let last = $last) {
      @for (item of group.visibleMenuItems; track $index) {
        @if (item.hasChildren) {
          @if (menuComponent.menu; as subMenu) {
            <a class="item" [attr.toggled]="item.toggled ? 'true' : null"
              [attr.disabled]="!item.enabled ? 'true': null"
              cdkMenuItem
              [cdkMenuItemDisabled]="!item.enabled"
              [cdkMenuTriggerFor]="subMenu"
              (cdkMenuItemTriggered)="item?.activate?.emit()"
              >
              <div class="icon-container">
                <div class="icon-backdrop"></div>
                @if (item.icon != null) {
                  <div class="icon">{{item.icon}}</div>
                }
              </div>
              <div class="text">{{ item.label }}</div>
              @if (item.hasChildren) {
                <div class="icon-like dropdown-indicator">{{Icons.next}}</div>
              }
            </a>
          }
          <app-context-menu #menuComponent
            [menuGroupsInput]="item.menuGroups.toArray()">
          </app-context-menu>
        } @else {
          <a class="item" cdkMenuItem [attr.toggled]="item.toggled && item.icon != null ? 'true' : null"
            [attr.disabled]="!item.enabled ? 'true': null"
            [cdkMenuItemDisabled]="!item.enabled"
            (cdkMenuItemTriggered)="item?.activate?.emit()">
            <div class="icon-container" [ngStyle]="item.iconColor != null && {'--icon-color': item.iconColor} || null">
              <div class="icon-backdrop"></div>
              @if (item.icon != null || item.toggled) {
                <div class="icon">
                  @if (item.icon != null) {
                    {{item.icon}}
                  } @else {
                    {{Icons.accept}}
                  }
                </div>
              }
            </div>
            <div class="text">{{ item.label }}</div>
          </a>
        }
      }
      @if (!last) {
        <hr />
      }
    }
  </div>
</ng-template>
